import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceOrderSuppliesModel } from 'src/app/models/maintenance/maintenance-order-supplies.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceOrderSuppliesService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(maintenanceOrderSupplies: MaintenanceOrderSuppliesModel): Observable<MaintenanceOrderSuppliesModel> {
    return this._httpClient.post<MaintenanceOrderSuppliesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.CreateAsync}`,
      maintenanceOrderSupplies);
  }

  createSuppliesByMaintenancePlan(maintenanceOrderId: number, articleId: number, maintenancePlan: number): Observable<boolean> {
    const params = new HttpParams()
      .set('maintenanceOrderId', maintenanceOrderId)
      .set('articleId', articleId)
      .set('maintenancePlan', maintenancePlan);
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.CreateSuppliesByMaintenancePlanAsync}`, null, { params: params });
  }

  deleteElement(maintenanceOrderSuppliesId: number): Observable<MaintenanceOrderSuppliesModel> {
    return this._httpClient.delete<MaintenanceOrderSuppliesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.DeleteAsync}/${maintenanceOrderSuppliesId}`);
  }

  deleteSomeSupplies(elementIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.DeleteSomeDetailsAsync}`,
      elementIds);
  }

  getAllMaintenanceOrderSuppliesWithPagination(maintenaceOrderId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('maintenaceOrderId', maintenaceOrderId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.GetAllMaintenanceOrderSuppliesWithPaginationAsync}`, { params: params });
  }

  getColumnsForTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.GetColumnsForTableAsync}`);
  }

  getListHomologousArticlesByArticleId(articleId: number, mainArticleId: number): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.GetListHomologousArticlesByArticleIdAsync}/${articleId}/${mainArticleId}`,);
  }

  getMaintenanceOrderSuppliesById(maintenanceOrderSuppliesId: number): Observable<MaintenanceOrderSuppliesModel> {
    return this._httpClient.get<MaintenanceOrderSuppliesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.GetByIdAsync}/${maintenanceOrderSuppliesId}`);
  }

  getMaintenanceOrderSuppliesByKeysAsync(maintenanceOrderId: number, articleId: number): Observable<MaintenanceOrderSuppliesModel> {
    return this._httpClient.get<MaintenanceOrderSuppliesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.GetMaintenanceOrderSuppliesByKeysAsync}/${maintenanceOrderId}/${articleId}`);
  }

  updateMaintenanceOrderSupplies(maintenanceOrderSupplies: MaintenanceOrderSuppliesModel): Observable<MaintenanceOrderSuppliesModel> {
    return this._httpClient.put<MaintenanceOrderSuppliesModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceOrderSupplies.UpdateAsync}`, maintenanceOrderSupplies);
  }


}
